module.exports = "<div id=\"link-editar\" ng-show=\"$ctrl.isAdmin()\">\n    <a ng-href=\"{{$ctrl.link}}\" class=\"btn btn-secondary bg-celeste\">\n        <span class=\"fa fa-pencil\"></span>\n    </a>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./client/components/link-editar/link-editar.html
// module id = 117
// module chunks = 0